module.exports = __webpack_public_path__ + "static/media/gameVideo3.bdd4fb03.mp4";